import { useContext,useEffect,useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";

import ArtworkDataContext from '@/context/ArtworkDataContext';
import useStateHandler from '@/hooks/useStateHandler';
import UserService from '@/services/user.service';
import ArtworkImage from '@/shared-components/cards/components/ArtworkImage';
import PictureViewer from '@/shared-components/popups/components/PictureViewer';
import store from '@/store';
import GlobalActions from '@/store/actions/global.actions';

import './styles/PicturesSlider.css';

export default function PicturesSlider({ setActiveSlide, setSwiper }) {
  const { artworkData,socialsData, setSocialsData } = useContext(ArtworkDataContext);
  const [pictureToZoom, setPictureToZoom] = useState(null);
  
  const { cacheHandler } = useStateHandler();

  const cacheKey = `user_actions.like.ARTWORK_${artworkData._id}`;
  const isLikedInCache = cacheHandler.getCacheValue(cacheKey)?.data;

  const handleDoubleLikeArtwork = async () => {
    if (!isLikedInCache) {
      try {
        await UserService.likeItem("ARTWORK", artworkData._id);
        store.dispatch(GlobalActions.triggerAction(setSocialsData({
          ...socialsData,
          is_liked: true,
          likes_count: socialsData.likes_count + 1
        })));
        cacheHandler.storeInCache(cacheKey, true, { type: "@cache/no-expiration" });

      } catch (error) {
        console.error("Failed to like artwork: ", error);
      }
    }
  };

  useEffect(() => {
    if (!isLikedInCache) {
      store.dispatch(GlobalActions.triggerAction(setSocialsData({
        ...socialsData,
        is_liked: false,
      })));
    }
  }, [isLikedInCache]);

  return (
    <>
      <div className="artwork-view-pictures-slider__container element-non-selectable">
        <Swiper 
          className="artwork-view-pictures-slider__swiper" 
          spaceBetween={10} 
          onInit={swiper => setSwiper(swiper)} 
          onSlideChange={swiper => setActiveSlide(swiper.activeIndex)} 
          simulateTouch={false}
        >
          <SwiperSlide>
            <ArtworkImage 
              artworkData={artworkData}
              image={artworkData.artwork_media.artwork_main_picture.image_id} 
              imageClassName="artwork-view-pictures-slider__artwork-picture" 
              imageTemplateClassName="artwork-view-pictures-slider__artwork-picture template" 
              onClick={()=>setPictureToZoom(artworkData.artwork_media.artwork_main_picture.image_id)}
              onDoubleClick={()=>{
                handleDoubleLikeArtwork();
              }}
            />
          </SwiperSlide>

          {artworkData.artwork_media.artwork_secondary_pictures.map(secondaryPicture => (
            <SwiperSlide key={secondaryPicture.image_id}>
              <ArtworkImage 
                artworkData={artworkData}
                image={secondaryPicture.image_id} 
                imageClassName="artwork-view-pictures-slider__artwork-picture" 
                imageTemplateClassName="artwork-view-pictures-slider__artwork-picture template" 
                onClick={()=>setPictureToZoom(secondaryPicture.image_id)}
                onDoubleClick={()=>{
                  handleDoubleLikeArtwork();
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div> 
            
      <PictureViewer picture={pictureToZoom} close={()=>setPictureToZoom(null)}/>
    </>
  );
}
